// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__3pr_c","title":"main_title__cVY2A"};